import { Card as CardAntd, Input } from 'antd';
import styled, { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .height-85 {
    height: '85vh';
    min-height: '85vh';
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  .tabAtivo {
    color: #1890FF;
    border: 1px solid #1890FF !important;
  }
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 12px 24px;
  }
`;

export const LabelCheckbox = styled.div`
  color: #4f4f4f !important;
`;

export const WrapperCheckbox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;

  ${props =>
    props.noMarginTop &&
    css`
      margin-top: 0px;
    `}
`;

export const DividerLeft = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const DividerRight = styled.label`
  cursor: pointer;
`;

export const CustomParagraph = styled.p`
  margin: 0px;
  padding: 0px;
`;

export const CustomLabel = styled.p`
  font-weight: bold;
  color: #6a6a6a;
`;

export const CustomInput = styled(Input)`
  color: #6a6a6a;
`;

export const CustomItemTitle = styled.p`
  color: #6a6a6a;
  font-size: 18px;
  font-weight: bold;

  ${props =>
    props.withMarginTop &&
    css`
      margin-top: 20px;
    `}
`;
